import { ComponentType, createSortOpenEvent, createSortOpenEventPayload, PageType } from '@qantasexperiences/analytics';
import { sortOpen } from 'store/search/searchActions';

const emitSortOpenEvent = () => {
  return createSortOpenEvent(
    createSortOpenEventPayload({
      componentVariant: 'search results sort',
      componentType: ComponentType.SORT,
      pageType: PageType.SEARCH,
    }),
  );
};

export default { [sortOpen.type]: emitSortOpenEvent };
